import { render, staticRenderFns } from "./rateDescription.vue?vue&type=template&id=e29f4c50&scoped=true"
import script from "./rateDescription.vue?vue&type=script&lang=js"
export * from "./rateDescription.vue?vue&type=script&lang=js"
import style0 from "./rateDescription.vue?vue&type=style&index=0&id=e29f4c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29f4c50",
  null
  
)

export default component.exports